import React from "react";
import {
  FaMountainCity,
  FaArrowUpFromGroundWater,
  FaCompassDrafting,
  FaTrowelBricks,
  FaHelmetSafety
} from "react-icons/fa6";
import { BiCheckShield } from "react-icons/bi";
import { BsArrowRight, BsBrightnessAltHigh, BsFileEasel } from "react-icons/bs";
import mainImg from "../assets/img/alt-services.jpg";
import { useTranslation } from "react-i18next";

const Welcometocompany = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      icon: <FaMountainCity />,
      title: t("services.items.1.title"),
      description: t("services.items.1.description"),
      delay: 100
    },
    {
      id: 2,
      icon: <FaArrowUpFromGroundWater />,
      title: t("services.items.2.title"),
      description: t("services.items.2.description"),
      delay: 200
    },
    {
      id: 3,
      icon: <FaCompassDrafting />,
      title: t("services.items.3.title"),
      description: t("services.items.3.description"),
      delay: 300
    },
    {
      id: 4,
      icon: <FaTrowelBricks />,
      title: t("services.items.4.title"),
      description: t("services.items.4.description"),
      delay: 400
    },
    {
      id: 5,
      icon: <FaHelmetSafety />,
      title: t("services.items.5.title"),
      description: t("services.items.5.description"),
      delay: 500
    },
    {
      id: 6,
      icon: <FaArrowUpFromGroundWater />,
      title: t("services.items.6.title"),
      description: t("services.items.6.description"),
      delay: 600
    }
  ];

  const iconBoxes = [
    {
      id: 1,
      icon: <BsFileEasel className="flex-shrink-0" />,
      title: t("services.alt.boxes.1.title"),
      link: "#",
      description: t("services.alt.boxes.1.description"),
      delay: 300
    },
    {
      id: 2,
      icon: <BiCheckShield className="flex-shrink-0" />,
      title: t("services.alt.boxes.2.title"),
      link: "#",
      description: t("services.alt.boxes.2.description"),
      delay: 400
    },
    {
      id: 3,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      title: t("services.alt.boxes.3.title"),
      link: "#",
      description: t("services.alt.boxes.3.description"),
      delay: 500
    },
    {
      id: 4,
      icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
      title: t("services.alt.boxes.4.title"),
      link: "#",
      description: t("services.alt.boxes.4.description"),
      delay: 600
    }
  ];

  return (
    <section id="alt-services" className="alt-services section">
      <div className="container">
        <div className="row justify-content-around gy-4">
          <div
            className="features-image col-lg-6"
            data-aos="fade-up"
            data-aos-delay={iconBoxes[0].delay - 200}
          >
            <img src={mainImg} alt="" loading="lazy" decoding="async" />
          </div>

          <div
            className="col-lg-5 d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay={200}
          >
            <h3>{t("welcometocompany.alt.desc")}</h3>

            <div className="icon-box d-flex position-relative" data-aos="fade-up">
              <div>
                <p>{t("welcometocompany.alt.boxes.1.description1")}</p>
              </div>
            </div>

            <div className="icon-box d-flex position-relative" data-aos="fade-up">
              <div>
                <p>{t("welcometocompany.alt.boxes.1.description2")}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Welcometocompany;
